import React, { useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "react-toastify";
import { Modal } from "../../../components";

interface IProps {
  customer: any;
  onClose: () => void;
}

export const CustomerJsonExportModal: React.FC<IProps> = ({ customer, onClose }) => {
  const [copied, setCopied] = useState(false);

  const json = JSON.stringify(
    customer,
    (key, value) => (key === "__typename" ? undefined : value),
    2
  );

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(json);
      setCopied(true);
      toast.success("JSON copié dans le presse-papier");
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      toast.error("Impossible de copier le JSON");
    }
  };

  return (
    <Modal title={`Export JSON — ${customer?.name ?? ""}`} onClose={onClose}>
      <div className="mb-3 flex justify-end">
        <button
          type="button"
          onClick={handleCopy}
          className="inline-flex items-center gap-2 px-3 py-1.5 rounded text-sm font-medium bg-indigo-600 text-white hover:bg-indigo-700"
        >
          {copied ? <Check size={16} /> : <Copy size={16} />}
          {copied ? "Copié" : "Copier"}
        </button>
      </div>
      <textarea
        readOnly
        value={json}
        onClick={(e) => (e.target as HTMLTextAreaElement).select()}
        className="input w-full font-mono text-xs h-96 resize-none"
      />
    </Modal>
  );
};
